type HomeNavigationItem = {
  title: string;
  description: string;
  href: string;
  image: string;
  catalogTarget?: string;
};

type HomeNavigationPanel = {
  key: 'newcomer' | 'catalog';
  title: string;
  ariaLabel: string;
  allLabel: string;
  allHref: string;
  allCatalogTarget?: string;
  items: HomeNavigationItem[];
};

function panelsFor(gameKey: string): HomeNavigationPanel[] {
  const base = `/${gameKey}`;
  return [
    {
      key: 'newcomer',
      title: '新人专区',
      ariaLabel: '新人入门导航',
      allLabel: '查看更多',
      allHref: `${base}/dguides`,
      items: [
        {
          title: '下载与登录',
          description: '安装游戏 · 账号准备',
          href: `${base}/guide?title=下载与登录&type=新手攻略`,
          image: 'newcomer-login.jpg',
        },
        {
          title: '新手上路必看',
          description: '基础机制 · 首发阵容',
          href: `${base}/guide?title=新手上路必看&type=新手攻略`,
          image: 'newcomer-start.jpg',
        },
        {
          title: '资源获取指南',
          description: '日常收益 · 活动奖励',
          href: `${base}/guide?title=资源获取指南&type=新手攻略`,
          image: 'newcomer-resources.jpg',
        },
        {
          title: '资源投入规划',
          description: '培养顺序 · 少走弯路',
          href: `${base}/guide?title=资源投入规划&type=新手攻略`,
          image: 'newcomer-plan.jpg',
        },
      ],
    },
    {
      key: 'catalog',
      title: '游戏资料库',
      ariaLabel: '游戏资料库导航',
      allLabel: '查看更多',
      allHref: `${base}/dcatalog`,
      allCatalogTarget: 'heroes',
      items: [
        {
          title: '英雄图鉴',
          description: '角色 · 属性 · 职业',
          href: `${base}/dcatalog`,
          image: 'catalog-heroes.jpg',
          catalogTarget: 'heroes',
        },
        {
          title: '卡牌图鉴',
          description: '卡牌 · 效果 · 搭配',
          href: `${base}/dcatalog`,
          image: 'catalog-cards.jpg',
          catalogTarget: 'cards',
        },
        {
          title: '装备图鉴',
          description: '武器 · 护具 · 词条',
          href: `${base}/dcatalog`,
          image: 'catalog-equipment.jpg',
          catalogTarget: 'equipment',
        },
        {
          title: '奖励图鉴',
          description: '道具 · 奖励 · 来源',
          href: `${base}/dcatalog`,
          image: 'catalog-rewards.jpg',
          catalogTarget: 'rewards',
        },
      ],
    },
  ];
}

function escapeHtml(value: string) {
  return value
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;')
    .replaceAll("'", '&#039;');
}

function catalogAttribute(target?: string) {
  return target ? ` data-catalog-jump="${escapeHtml(target)}"` : '';
}

function renderPanel(panel: HomeNavigationPanel) {
  const items = panel.items
    .map(
      (
        item,
      ) => `<a href="${escapeHtml(item.href)}"${catalogAttribute(item.catalogTarget)}>
        <img class="home-navigation-thumb" src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7" alt="" width="44" height="44" data-home-tile-pending="1">
        <span class="home-navigation-copy"><strong>${escapeHtml(item.title)}</strong><small>${escapeHtml(item.description)}</small></span>
        <i aria-hidden="true">→</i>
      </a>`,
    )
    .join('');

  return `<section class="home-navigation-section" data-home-navigation="${panel.key}" aria-label="${escapeHtml(panel.ariaLabel)}">
    <div class="section-title">
      <span>${escapeHtml(panel.title)}</span>
      <a class="home-navigation-all" href="${escapeHtml(panel.allHref)}"${catalogAttribute(panel.allCatalogTarget)}>${escapeHtml(panel.allLabel)}</a>
    </div>
    <nav class="home-navigation-grid" aria-label="${escapeHtml(panel.ariaLabel)}">${items}</nav>
  </section>`;
}

export function renderHomeNavigationPanels(gameKey: string) {
  return `<div class="home-resource-row">${panelsFor(gameKey).map(renderPanel).join('')}</div>`;
}
